import React from 'react';
import founder from '../../assests/img/founder.jpg';

const FounderMessage = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Founder’s Message</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Founder’s Message
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p>
                                                    <img style={{ paddingLeft: "15px", float: "right" }} src={founder} alt="founder" width="293" height="305" />
                                                    I warmly welcome you to Karamchand Memorial School, where you will discover a very special, inclusive and friendly community. Every child in our care will be an individual. We aim to uphold the values of building self-esteem and self-belief in a very supportive and kind atmosphere.
                                                </p>
                                                <p>
                                                    Our much-loved school is steeped in history and our ancient civilisational and cultural ethos, yet our teaching methodology will be advanced, innovative and modern. At Karamchand’s we’ll strive hard to provide a very happy, caring and nurturing environment for our pupils.
                                                </p>
                                                <p>
                                                    We have a very dedicated staff who’ll do their utmost to provide excellent opportunities for children to learn, explore, experiment, develop and extend their interests, skills and talents. The children will be at the very centre of all we do, and we’ll provide the very best academic and spiritual care. Our provision for sport and for the expressive arts, including art, drama, music and dance will be exceptional. Our role is to ignite our pupil’s interests and talents through a wide range of activities. We aim to provide them with skills for life, including how to think creatively, how to be curious, how to work well together in teams and how to help to develop resilience.
                                                </p>
                                                <p>
                                                    We believe that the warmth, enthusiasm and energy of our inspirational teaching and support staff will be truly unique. I invite you to visit to discover our remarkable school in person.
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="about-us" target="_self" className="submenu">
                                                        About Us
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-inspiration"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Inspiration
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="history" target="_self" className="submenu">
                                                        History
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a className="submenu">
                                                        Messages
                                                    </a>
                                                    <div className="founder_link">
                                                        <div className="subMenubg">
                                                            <a href="founder-message" className="submenu">
                                                                Founder’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="director-message" className="submenu">
                                                                Director’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="patron-message" className="submenu">
                                                                Patron Message
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="our-aims" target="_self" className="submenu">
                                                        Our Aims
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-ethos"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Ethos
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-vision.html"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Vision
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default FounderMessage;